import { render, staticRenderFns } from "./PaperEncode.vue?vue&type=template&id=14780b37"
import script from "./PaperEncode.vue?vue&type=script&lang=js"
export * from "./PaperEncode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports